/**
 * Remove tudo que não é dígito. Forma canônica de armazenamento de CPF
 * em todo o sistema (nunca com pontuação) — ver
 * docs/architecture/007-identidade-portal-cliente.md.
 */
export function normalizarCpf(cpf) {
    return cpf.replace(/\D/g, '');
}
function digitoVerificador(digitosBase) {
    let soma = 0;
    let peso = digitosBase.length + 1;
    for (const digito of digitosBase) {
        soma += digito * peso;
        peso -= 1;
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
}
/**
 * Valida um CPF pelo algoritmo oficial de dígitos verificadores.
 * Aceita o valor já normalizado (recomendado) ou com pontuação —
 * normaliza internamente antes de validar. Rejeita sequências de dígito
 * repetido (ex: "111.111.111-11"), que passariam no cálculo de dígito
 * verificador mas nunca são CPFs válidos de verdade.
 */
export function cpfValido(cpf) {
    const digitosStr = normalizarCpf(cpf);
    if (!/^\d{11}$/.test(digitosStr))
        return false;
    if (/^(\d)\1{10}$/.test(digitosStr))
        return false;
    const digitos = digitosStr.split('').map(Number);
    const primeiroDigito = digitoVerificador(digitos.slice(0, 9));
    const segundoDigito = digitoVerificador(digitos.slice(0, 10));
    return primeiroDigito === digitos[9] && segundoDigito === digitos[10];
}
/**
 * Mascara um CPF para exposição em resposta de API (ADR 012) — mantém
 * visíveis apenas os 2 últimos dígitos, no formato `***.***.***-XX`.
 * O CPF completo nunca é retornado pela API comum de clientes; esta
 * função é só de apresentação, nunca aplicada antes de persistir ou de
 * comparar CPF internamente (`cpfValido`/repositório continuam operando
 * sobre o valor canônico completo).
 */
export function mascararCpf(cpf) {
    const normalizado = normalizarCpf(cpf);
    const ultimosDois = normalizado.slice(-2);
    return `***.***.***-${ultimosDois}`;
}
/**
 * Formata um CPF completo (11 dígitos) para exibição administrativa, no
 * padrão `XXX.XXX.XXX-XX` — usado só pelo lado que já recebeu o CPF sem
 * máscara (ADR 012, revisão 2026-08-28: papel `admin` na API de
 * Clientes). Nunca reformata um valor já mascarado
 * (`***.***.***-XX` normaliza para só 2 dígitos, não 11) — nesse caso
 * devolve o valor de entrada sem alteração, para nunca corromper a
 * máscara vinda da API.
 */
export function formatarCpfExibicao(cpf) {
    const normalizado = normalizarCpf(cpf);
    if (normalizado.length !== 11)
        return cpf;
    return `${normalizado.slice(0, 3)}.${normalizado.slice(3, 6)}.${normalizado.slice(6, 9)}-${normalizado.slice(9)}`;
}
//# sourceMappingURL=cpf.js.map